<script>
  import 'swiper/element/css/effect-fade';

  import { onMount } from 'svelte';
  import { page, inertia } from '@inertiajs/svelte';
  import { Controller, EffectFade, Navigation, Pagination } from 'swiper';

  import SwiperNav from '$lib/swiper/Nav.svelte';
  import SwiperPagination from '$lib/swiper/Pagination.svelte';
  import PortfolioWorkItem from './Item.svelte';
  import responsive from '@/js/utils/responsive';

  export let items;
  export let type = 'default';

  let swiperEl, swiperDescEl, paginationEl, navPrevEl, navNextEl;

  let innerWidth = 0;

  $: mobile = innerWidth <= responsive.s;

  onMount(() => {
    // Main slider
    Object.assign(swiperEl, {
      modules: [Navigation, Pagination, EffectFade, Controller],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      controller: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        prevEl: navPrevEl,
        nextEl: navNextEl,
      },
    });

    swiperEl.initialize();

    // Description slider
    Object.assign(swiperDescEl, {
      modules: [EffectFade, Controller],
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      controller: true,
    });

    swiperDescEl.initialize();

    swiperEl.swiper.controller.control = swiperDescEl.swiper;
    swiperDescEl.swiper.controller.control = swiperEl.swiper;
  });
</script>

<div class="portfolio-slider">
  <div class="portfolio-slider__main">
    <!-- <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} /> -->

    <swiper-container bind:this={swiperEl} init={false}>
      {#each items as item}
        <swiper-slide>
          <div class="portfolio-item">
            <PortfolioWorkItem item={item.proto} />
          </div>
        </swiper-slide>
      {/each}
    </swiper-container>
  </div>

  <SwiperPagination bind:element={paginationEl} />

  <div class="portfolio-slider__bottom">
    <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} />

    <swiper-container bind:this={swiperDescEl} init={false}>
      {#each items as item}
        <swiper-slide>
          <div class="portfolio-info">
            <div class="flexbox h-sb v-e">
              <div class="col col-s-full">
                <div class="portfolio-info__title-and-cat">
                  <h3 class="portfolio-info__title h4">{item.title}</h3>

                  {#if item.cat}
                    <p class="portfolio-info__cat text-small">{item.cat}</p>
                  {/if}
                </div>
                {#if item.desc}
                  <p class="portfolio-info__desc text-small">{item.desc}</p>
                {/if}

                {#if 'home' == type}
                  <a
                    class="portfolio-info__more text-small text-link-for-btn"
                    href={item.url}
                    use:inertia
                  >
                    {$page.props.i18n.learn_more}
                    <i class="isax isax-arrow-right-1" />
                  </a>
                {/if}
              </div>
              <div class="col col-s-full portfolio-info__all">
                {#if 'home' == type && item.all}
                  <a
                    class="btn btn-icon btn-main btn-main--dark"
                    href={item.all.url}
                    use:inertia
                  >
                    <span>{item.all.title}</span>
                    <i class="isax isax-arrow-right-1" />
                  </a>
                {:else if mobile}
                  <a class="btn btn-icon btn-more" href={item.url} use:inertia>
                    <span>{$page.props.i18n.page.learn_more}</span>
                    <i class="isax isax-arrow-right-1" />
                  </a>
                {:else}
                  <a
                    class="btn btn-icon btn-main btn-main--dark"
                    href={item.url}
                    use:inertia
                  >
                    <span>{$page.props.i18n.page.learn_more}</span>
                    <i class="isax isax-arrow-right-1" />
                  </a>
                {/if}
              </div>
            </div>
          </div>
        </swiper-slide>
      {/each}
    </swiper-container>
  </div>
</div>

<style lang="scss">
  .portfolio-slider {
    position: relative;
    margin-top: 5rem;

    &__main {
      @include resp-min('s') {
        padding: {
          left: 13.5rem;
          right: 7rem;
        }
      }

      position: relative;

      :global .swiper-nav {
        @include resp-max('s') {
          display: none;
        }
      }
    }

    &__bottom {
      @include resp-max('s') {
        position: relative;
      }

      :global .swiper-nav {
        @include resp-min('s') {
          position: absolute;
          top: 21rem;
        }

        @include resp-max('s') {
          top: 5rem;
        }
      }
    }
  }

  .portfolio-info {
    @include resp-max('s') {
      padding: 0 5rem;
      text-align: center;
    }

    @include resp-max('xs') {
      padding: 0;
    }

    margin: 0 auto;
    max-width: 70rem;
    margin-top: 5rem;

    &__title-and-cat {
      @include resp-max('s') {
        min-height: 5rem;
      }
    }

    &__title {
      color: var(--royal);
    }

    &__cat {
      margin: 0.2rem 0 0;
      color: var(--royal-light);
    }

    &__desc {
      @include resp-max('s') {
        margin: 1rem auto 0;
      }
      color: var(--royal);
      margin: 2rem 0 0;
      max-width: 40rem;
    }

    &__more {
      color: var(--royal);

      @include resp-max('s') {
        margin: 3rem 0 0;
      }
      @include resp-min('s') {
        margin: 2rem 0 0;
      }
    }

    &__all {
      @include resp-max('s') {
        margin-top: 4rem;
      }
    }
  }
</style>
